import { render, staticRenderFns } from "./ErrorLogsHead.vue?vue&type=template&id=394cb87b&scoped=true"
import script from "./ErrorLogsHead.vue?vue&type=script&lang=js"
export * from "./ErrorLogsHead.vue?vue&type=script&lang=js"
import style0 from "./ErrorLogsHead.vue?vue&type=style&index=0&id=394cb87b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394cb87b",
  null
  
)

export default component.exports